// Notification.tsx - Composant pour afficher les notifications
import React from 'react';
import { Transition } from '@headlessui/react';
import { CheckCircleIcon, CircleAlert } from 'lucide-react';

interface NotificationProps {
  type: 'success' | 'error';
  message: string;
  isVisible: boolean;
}

const Notification: React.FC<NotificationProps> = ({ type, message, isVisible }) => {
  return (
    <Transition
      show={isVisible}
      enter="transition ease-out duration-300"
      enterFrom="transform -translate-y-2 opacity-0"
      enterTo="transform translate-y-0 opacity-100"
      leave="transition ease-in duration-200"
      leaveFrom="transform translate-y-0 opacity-100"
      leaveTo="transform -translate-y-2 opacity-0"
    >
      <div 
        className={`px-4 py-3 rounded-lg shadow-lg flex items-center ${
          type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
        }`}
      >
        {type === 'success' ? (
          <CheckCircleIcon className="w-5 h-5 mr-2" />
        ) : (
          <CircleAlert className="w-5 h-5 mr-2" />
        )}
        <span className="text-sm font-medium">{message}</span>
      </div>
    </Transition>
  );
};

export default Notification;
